/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalServiceGroupInfoRespVo } from './AdditionalServiceGroupInfoRespVo';
import {
    AdditionalServiceGroupInfoRespVoFromJSON,
    AdditionalServiceGroupInfoRespVoFromJSONTyped,
    AdditionalServiceGroupInfoRespVoToJSON,
    AdditionalServiceGroupInfoRespVoToJSONTyped,
} from './AdditionalServiceGroupInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseListAdditionalServiceGroupInfoRespVo
 */
export interface ResponseListAdditionalServiceGroupInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListAdditionalServiceGroupInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListAdditionalServiceGroupInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<AdditionalServiceGroupInfoRespVo>}
     * @memberof ResponseListAdditionalServiceGroupInfoRespVo
     */
    data?: Array<AdditionalServiceGroupInfoRespVo>;
}

/**
 * Check if a given object implements the ResponseListAdditionalServiceGroupInfoRespVo interface.
 */
export function instanceOfResponseListAdditionalServiceGroupInfoRespVo(value: object): value is ResponseListAdditionalServiceGroupInfoRespVo {
    return true;
}

export function ResponseListAdditionalServiceGroupInfoRespVoFromJSON(json: any): ResponseListAdditionalServiceGroupInfoRespVo {
    return ResponseListAdditionalServiceGroupInfoRespVoFromJSONTyped(json, false);
}

export function ResponseListAdditionalServiceGroupInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListAdditionalServiceGroupInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AdditionalServiceGroupInfoRespVoFromJSON)),
    };
}

export function ResponseListAdditionalServiceGroupInfoRespVoToJSON(json: any): ResponseListAdditionalServiceGroupInfoRespVo {
    return ResponseListAdditionalServiceGroupInfoRespVoToJSONTyped(json, false);
}

export function ResponseListAdditionalServiceGroupInfoRespVoToJSONTyped(value?: ResponseListAdditionalServiceGroupInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AdditionalServiceGroupInfoRespVoToJSON)),
    };
}

